import { useMemo } from 'react';
import useCurrentBreakPoint from 'hooks/useCurrentBreakPoint';

const DEFAULT_SLIDES_PER_VIEW = 4;

/**
 * @description Calculates number of items to shown in grid
 * @param {Array} items - array of items
 * @param {Object} breakpoints - swiper breakpoints https://github.com/nolimits4web/swiper/blob/f4afd9d0fec3be48c17ab75c462c23e69e98a571/src/types/swiper-options.d.ts#L707C11-L707C11
 * @param {Boolean} hasMoreItems - is it all items or not
 */
function useShowCompleteLastLineOfItems(items, breakpoints, hasMoreItems) {
  const currentBreakpoint = useCurrentBreakPoint(breakpoints);

  return useMemo(() => {
    if (!currentBreakpoint) return { items, slidesPerView: DEFAULT_SLIDES_PER_VIEW };

    const { slidesPerView } = breakpoints[currentBreakpoint] || { slidesPerView: DEFAULT_SLIDES_PER_VIEW };

    if (!hasMoreItems) return { items, slidesPerView };

    const rest = items.length % slidesPerView;

    return { items: items.slice(0, items.length - rest), slidesPerView };
  }, [currentBreakpoint, items, breakpoints, hasMoreItems]);
}

export default useShowCompleteLastLineOfItems;
